"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailValidator = void 0;
var constants_1 = require("../constants");
// FIX-ME Elment ui does not provides us proper types its still imature
// we need to figure out a way to get the types correct !!
// eslint-disable-next-line @typescript-eslint/ban-types
var emailValidator = function (_, email, callback) {
    if (!email) {
        callback(new Error(constants_1.VALIDATION_MESSAGE.REQUIRED_FIELD));
        return;
    }
    if (!isEmail(email)) {
        callback(new Error('Invalid Email'));
        return;
    }
    callback();
};
exports.emailValidator = emailValidator;
function isEmail(email) {
    // Taken from https://emailregex.com/
    var regExp = new RegExp("^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*" +
        '|"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*")' +
        '@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?' +
        '|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}' +
        '(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:' +
        '(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]' +
        '|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])$');
    return regExp.test(email);
}
